import PropTypes from "prop-types";
import React from "react";

const IgniteVideo = ({ igniteVideoId, attributes, isFocused }) => {
  const wrapperStyle = {
    position: "relative",
    outline: isFocused ? "2px solid blue" : "none",
  };

  // Lets a click select the void block instead of hitting the player iframe.
  const maskStyle = {
    display: isFocused ? "none" : "block",
    position: "absolute",
    top: "0",
    left: "0",
    height: "100%",
    width: "100%",
    cursor: "cell",
    zIndex: 1,
  };

  const iframeStyle = {
    display: "block",
  };

  const igniteVideoSrc = `${process.env.IGNITE_VIDEO_HOST}/player/index.html?id=${igniteVideoId}`;

  return (
    <div {...attributes}>
      <div style={wrapperStyle}>
        <div style={maskStyle} />
        <iframe
          src={igniteVideoSrc}
          title={`Ignite video ${igniteVideoId}`}
          width="426"
          height="240"
          frameBorder="0"
          scrolling="no"
          allow="autoplay; fullscreen"
          allowFullScreen
          style={iframeStyle}
        />
      </div>
    </div>
  );
};

IgniteVideo.propTypes = {
  igniteVideoId: PropTypes.string,
  attributes: PropTypes.object.isRequired,
  isFocused: PropTypes.bool.isRequired,
};

export default IgniteVideo;
